import React, { useEffect, useState } from 'react';
import client from '../api/client';

export default function RepActivity() {
  const [reps, setReps] = useState([]);
  const [selected, setSelected] = useState(null);
  const [activity, setActivity] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.get('/admin/affiliate/reps/activity/all')
      .then(r => { setReps(r.data); setLoading(false); })
      .catch(() => setLoading(false));
  }, []);

  const loadActivity = async (repId) => {
    setActivity(null);
    setSelected(repId);
    const r = await client.get('/admin/affiliate/reps/' + repId + '/activity');
    setActivity(r.data);
  };

  const fmt = (ts) => ts ? new Date(ts).toLocaleString() : '—';
  const fmtDur = (secs) => {
    if (!secs) return '—';
    const m = Math.floor(secs / 60), s = secs % 60;
    return m > 0 ? m + 'm ' + s + 's' : s + 's';
  };

  return (
    <div style={{ padding: 32, fontFamily: 'Inter, sans-serif' }}>
      <h2 style={{ fontSize: 24, fontWeight: 800, color: '#1a1a2e', margin: '0 0 8px' }}>Rep Activity</h2>
      <p style={{ color: '#888', fontSize: 14, margin: '0 0 24px' }}>Track logins, emails, calls, and session time per partner</p>

      <div style={{ display: 'flex', gap: 24 }}>
        {/* Rep list */}
        <div style={{ width: 280, flexShrink: 0 }}>
          {loading ? <div style={{ color: '#888', fontSize: 14 }}>Loading...</div> :
            reps.map((rep, i) => (
              <div key={i} onClick={() => loadActivity(rep.id)}
                style={{ background: selected === rep.id ? '#eff4ff' : '#fff', border: '1px solid ' + (selected === rep.id ? '#c0d0ff' : '#e0e4f0'), borderRadius: 10, padding: '12px 14px', marginBottom: 8, cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                  {rep.photo_url
                    ? <img src={rep.photo_url} alt="" style={{ width: 36, height: 36, borderRadius: '50%', objectFit: 'cover' }} />
                    : <div style={{ width: 36, height: 36, borderRadius: '50%', background: '#eff4ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 800, color: '#1a3cff' }}>
                        {(rep.name || '?').split(' ').map(w => w[0]).join('').toUpperCase().substring(0, 2)}
                      </div>
                  }
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 700, color: '#1a1a2e' }}>{rep.name}</div>
                    <div style={{ fontSize: 11, color: '#888' }}>{rep.role_applied?.replace('_', ' ')}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ fontSize: 11, color: rep.status === 'ACTIVE' ? '#0a8a40' : '#e05c5c', fontWeight: 700 }}>{rep.status}</div>
                  </div>
                </div>
                <div style={{ display: 'flex', gap: 12, marginTop: 8, paddingTop: 8, borderTop: '1px solid #f0f4ff' }}>
                  <div style={{ textAlign: 'center', flex: 1 }}>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#1a3cff' }}>{rep.total_logins || 0}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>Logins</div>
                  </div>
                  <div style={{ textAlign: 'center', flex: 1 }}>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#0a8a40' }}>{rep.total_emails || 0}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>Emails</div>
                  </div>
                  <div style={{ textAlign: 'center', flex: 1 }}>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#b45309' }}>{rep.total_calls || 0}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>Calls</div>
                  </div>
                  <div style={{ textAlign: 'center', flex: 1 }}>
                    <div style={{ fontSize: 16, fontWeight: 800, color: '#7c3aed' }}>{rep.week_emails || 0}</div>
                    <div style={{ fontSize: 10, color: '#888' }}>This wk</div>
                  </div>
                </div>
              </div>
            ))
          }
        </div>

        {/* Activity detail */}
        <div style={{ flex: 1 }}>
          {!selected && <div style={{ background: '#fff', border: '1px solid #e0e4f0', borderRadius: 12, padding: 40, textAlign: 'center', color: '#888', fontSize: 14 }}>Select a rep to view their activity</div>}

          {selected && !activity && <div style={{ background: '#fff', border: '1px solid #e0e4f0', borderRadius: 12, padding: 40, textAlign: 'center', color: '#888', fontSize: 14 }}>Loading...</div>}

          {activity && (() => {
            const rep = reps.find(r => r.id === selected);
            return (
              <div>
                {/* Stats cards */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 12, marginBottom: 20 }}>
                  {[
                    { label: 'Total Logins', value: activity.totalLogins, color: '#1a3cff', bg: '#eff4ff' },
                    { label: 'Total Emails', value: activity.totalEmails, color: '#0a8a40', bg: '#f0fff6' },
                    { label: 'Total Calls', value: activity.totalCalls, color: '#b45309', bg: '#fff8ec' },
                    { label: 'This Week Emails', value: activity.weekEmails, color: '#7c3aed', bg: '#f5f3ff' },
                  ].map((s, i) => (
                    <div key={i} style={{ background: s.bg, borderRadius: 10, padding: '14px 16px' }}>
                      <div style={{ fontSize: 11, color: '#888', marginBottom: 4 }}>{s.label}</div>
                      <div style={{ fontSize: 24, fontWeight: 800, color: s.color }}>{s.value || 0}</div>
                    </div>
                  ))}
                </div>

                {/* Last login */}
                {activity.lastLogin && (
                  <div style={{ background: '#fff', border: '1px solid #e0e4f0', borderRadius: 10, padding: '12px 16px', marginBottom: 16, fontSize: 13 }}>
                    <strong>Last login:</strong> {fmt(activity.lastLogin.login_at)}
                    {activity.lastLogin.logout_at && <span style={{ color: '#888' }}> · Logged out: {fmt(activity.lastLogin.logout_at)} · Duration: {fmtDur(activity.lastLogin.duration_seconds)}</span>}
                  </div>
                )}

                {/* Recent activity */}
                <div style={{ background: '#fff', border: '1px solid #e0e4f0', borderRadius: 12, overflow: 'hidden' }}>
                  <div style={{ padding: '14px 18px', borderBottom: '1px solid #f0f4ff', fontWeight: 700, fontSize: 14, color: '#1a1a2e' }}>Recent Activity</div>
                  {(!activity.recentActivity || activity.recentActivity.length === 0)
                    ? <div style={{ padding: 24, textAlign: 'center', color: '#888', fontSize: 13 }}>No activity logged yet</div>
                    : activity.recentActivity.map((a, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 12, padding: '10px 18px', borderBottom: '1px solid #f5f5f5' }}>
                        <div style={{ width: 32, height: 32, borderRadius: '50%', background: a.activity_type === 'EMAIL' ? '#eff4ff' : a.activity_type === 'CALL' ? '#fff8ec' : '#f5f3ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>
                          {a.activity_type === 'EMAIL' ? '✉' : a.activity_type === 'CALL' ? '📞' : '📝'}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: '#1a1a2e' }}>
                            {a.activity_type}
                            {a.prospect_name && <span style={{ fontWeight: 400, color: '#555' }}> — {a.prospect_name}</span>}
                          </div>
                          <div style={{ fontSize: 11, color: '#888' }}>{a.description}</div>
                        </div>
                        <div style={{ fontSize: 11, color: '#aaa', textAlign: 'right' }}>
                          {fmt(a.created_at)}
                          {a.duration_seconds > 0 && <div>{fmtDur(a.duration_seconds)}</div>}
                        </div>
                      </div>
                    ))
                  }
                </div>
              </div>
            );
          })()}
        </div>
      </div>
    </div>
  );
}
